import { Link } from "react-router-dom";
import { FaGoogle, FaFacebookF } from "react-icons/fa";
import PageHeader from "../../components/layout/PageHeader";

export default function Login() {
  return (
    <>
      <PageHeader title="Login" crumbs={[{ label: "Login" }]} />
      <section className="section">
        <div className="container">
          <div className="auth-wrap">
            <h2>Welcome Back</h2>
            <p className="sub">Login to your Taxi24hrs account</p>
            <form onSubmit={(e) => e.preventDefault()}>
              <div className="field">
                <label>Email Address</label>
                <input type="email" placeholder="you@example.com" required />
              </div>
              <div className="field">
                <label>Password</label>
                <input type="password" placeholder="••••••••" required />
              </div>
              <div className="form-meta">
                <label><input type="checkbox" /> Remember me</label>
                <Link to="/forgot-pwd">Forgot password?</Link>
              </div>
              <button type="submit" className="btn btn-primary btn-block">Login</button>
            </form>
            <div className="flex gap-2" style={{ marginTop: 18 }}>
              <button className="btn btn-outline btn-block"><FaGoogle /> Google</button>
              <button className="btn btn-outline btn-block"><FaFacebookF /> Facebook</button>
            </div>
            <p className="auth-alt">
              Don't have an account? <Link to="/register">Register</Link>
            </p>
          </div>
        </div>
      </section>
    </>
  );
}
